import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../api";
const shopSlice = createSlice({
  name: "shop",
  initialState: {
    type: false, logo: 'https://eg-shield.nyc3.cdn.digitaloceanspaces.com/logo/none.png',
    address: '',
    email: '',
    template: "",
    products: [{
      id: 1,
      name: "",
      price: 29.99,
      image: ["https://eg-shield.nyc3.cdn.digitaloceanspaces.com/id-loading-1.gif"]
    }],
    product: {
      id: 1,
      name: "",
      price: "",
      image: ["https://eg-shield.nyc3.cdn.digitaloceanspaces.com/id-loading-1.gif"]
    },
    banner: {
      image: "https://eg-shield.nyc3.cdn.digitaloceanspaces.com/id-loading-1.gif",
      title: "",
      subtitle: ""
    },
    ads: [
      {
        title: "",
        description: "",
        image: "https://eg-shield.nyc3.cdn.digitaloceanspaces.com/id-loading-1.gif"
      },
      {
        title: "",
        description: "",
        image: "https://eg-shield.nyc3.cdn.digitaloceanspaces.com/id-loading-1.gif"
      }
    ], last_ads: {
      title: "",
      description: "",
      image: "https://eg-shield.nyc3.cdn.digitaloceanspaces.com/id-loading-1.gif"
    },
    page: 1, totalPages: 1, about_us: "",
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getProducts.fulfilled, (state, action) => {
      const res = action.payload;
      state.products = res
    }).addCase(getProduct.fulfilled, (state, action) => {
      const res = action.payload;
      state.product = res
    }).addCase(getShop.fulfilled, (state, action) => {
      const res = action.payload;
      state.products = res.products
      state.page = res.page
      state.total = res.total
      state.totalPages = res.totalPages
    }).addCase(getInit.fulfilled, (state, action) => {
      const res = action.payload;
      state.about_us = res.about_us
      state.address = res.address
      state.logo = res.logo
      state.template = res.template
      state.banner = res.banner
      state.last_ads = res.last_ads
      state.ads = res.ads
    })

  },
});

export const getProducts = createAsyncThunk("shop/getProducts", async (newTodo) => {
  const res = await GET("/products", newTodo);
  return res.data;
});

export const getProduct = createAsyncThunk("shop/getProduct", async (newTodo) => {
  const res = await GET("/product", newTodo);
  return res.data;
});

export const getShop = createAsyncThunk("shop/getShop", async (newTodo) => {
  const res = await GET("/shop", newTodo);
  return res.data;
});

export const getInit = createAsyncThunk("shop/getInit", async (newTodo) => {
  const res = await GET("/init", newTodo);
  return res.data;
});


export default shopSlice;
